/**
 * @(#)2019/9/6.
 * tag组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Basics from "./Basics";
import { get } from "../../utils";
import { Progress as AntdProgress } from "antd";
import React, { Component } from "react";
import { YxComponent, Connection } from "../YxComponent";
/**
 * @param children {string|ReactNode}
 * @param strokeColor {string}: 颜色
 * @param ... 继承 antd  Progress 参数
 * @returns React.Component
 */
const defaul = function () {
  return {
    children: "",
    strokeColor: "", //进度条颜色  //type1 , type2 type3
  };
};
@Connection(defaul)
class Progress extends YxComponent {
  static defaultProps = {};
  propductionHtml() {
    const props = { ...this.props, percent: Number(this.props.percent) || 0 };
    let html = <AntdProgress {...props}></AntdProgress>;
    return html;
  }

  render() {
    return (
      <div className={`yx_Progress yx_ProgressBg_${this.props.strokeColor}`}>
        {this.propductionHtml()}
      </div>
    );
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Progress.js